<template>
    <div
        class="announcement left-stripe" 
        :style="{'--base-color': color}"
    >
        <slot/>
    </div>
</template>

<script>

export default {
    name: "LeftStripeLayout",

    props: {
        color: {
            type: String,
            required: true
        },
    },
}
</script>

<style scoped>
    
</style>
